import { CheckBox } from 'common/components/Checkbox/Checkbox'
import { useGet } from 'common/hooks/useApi'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { ApiPathsJobs } from 'services/jobs/jobs.service'
import { IJobsListQuery } from './CommunityJobs'
import { queryInitialState } from './CommunityJobs.state'
import { IGroupedJobs } from './CommunityJobs.types'

interface IProps {
  query: IJobsListQuery
  setQuery: Dispatch<SetStateAction<IJobsListQuery>>
}

export const CommunityJobsBaseFilters = ({ query, setQuery }: IProps) => {
  const [counts, setCounts] = useState<IGroupedJobs | undefined>()

  const { data } = useGet<IGroupedJobs>(ApiPathsJobs.getPublicJobsCount(query.filters.jobCategories), {
    onSuccess: (data) => setCounts(data),
  })

  useEffect(() => {
    if (data) {
      setCounts(data)
    }
  }, [data])

  const onSelectMostWanted = (positionId: string) => () => {
    setQuery((c) => {
      const positions = c.filters.positions.includes(positionId)
        ? c.filters.positions.filter((id) => id !== positionId)
        : [...c.filters.positions, positionId]
      return {
        ...queryInitialState,
        filters: { ...c.filters, positions },
      }
    })
  }

  const onSelectJobCategory = (jobCategoryId: string) => () => {
    setQuery((c) => {
      const jobCategories = c.filters.jobCategories.includes(jobCategoryId)
        ? c.filters.jobCategories.filter((id) => id !== jobCategoryId)
        : [...c.filters.jobCategories, jobCategoryId]
      return {
        ...queryInitialState,
        filters: { ...c.filters, jobCategories },
      }
    })
  }

  const onClear = (filter: 'jobCategories' | 'positions') => () => {
    setQuery((c) => ({ ...c, filters: { ...c.filters, [filter]: [] } }))
  }
  return (
    <div className="flex flex-column gap-3">
      <div className="relative">
        <div className="flex justify-content-between align-items-center">
          <h3 className="text-md mb-2">By job category</h3>
          {!!query.filters.jobCategories.length && (
            <span className="text-md cursor-pointer" onClick={onClear('jobCategories')}>
              Clear all
            </span>
          )}
        </div>

        <div className="flex flex-column gap-2 px-2">
          {counts?.byJobCategory.map((group) => (
            <div
              onClick={onSelectJobCategory(group.jobCategoryId)}
              className={'chinese-black cursor-pointer flex gap-2 align-items-center'}
              key={group.jobCategoryId}
            >
              <CheckBox
                checked={query.filters.jobCategories.includes(group.jobCategoryId)}
                onChange={() => undefined}
              />
              {`${group.jobCategoryName} (${group.count})`}
            </div>
          ))}
        </div>
      </div>

      <div className="relative">
        <div className="flex justify-content-between align-items-center">
          <h3 className="text-md mb-2">Most wanted</h3>
          {!!query.filters.positions.length && (
            <span className="text-md cursor-pointer" onClick={onClear('positions')}>
              Clear all
            </span>
          )}
        </div>

        <div className="flex flex-column gap-2 px-2">
          {counts?.byPosition.map((group) => (
            <div
              onClick={onSelectMostWanted(group.positionId)}
              className={'chinese-black cursor-pointer flex gap-2 align-items-center'}
              key={group.positionId}
            >
              <CheckBox checked={query.filters.positions.includes(group.positionId)} onChange={() => undefined} />
              {`${group.positionName} (${group.count})`}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
